"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var matchesState_1 = require("./matchesState");
function mapState(stateMap, stateId) {
    var foundStateId;
    Object.keys(stateMap).forEach(function (mappedStateId) {
        if (matchesState_1.default(mappedStateId, stateId) &&
            (!foundStateId || stateId.length > foundStateId.length)) {
            foundStateId = mappedStateId;
        }
    });
    return stateMap[foundStateId];
}
exports.default = mapState;



//////////////////
// WEBPACK FOOTER
// ./~/xstate/lib/mapState.js
// module id = 1319
// module chunks = 168707334958949